/* eslint-disable */
import { produce } from "immer";
import {
  FC_HOME_FETCH_START,
  FC_HOME_FETCH_SUCCESS,
  FC_HOME_FETCH_FAILURE,
} from "../actions/types";

const futureCalculatorHome = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case FC_HOME_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case FC_HOME_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case FC_HOME_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default futureCalculatorHome;
